import { render, staticRenderFns } from "./MessageEditView.vue?vue&type=template&id=46034eef"
import script from "./MessageEditView.vue?vue&type=script&lang=js"
export * from "./MessageEditView.vue?vue&type=script&lang=js"
import style0 from "./MessageEditView.vue?vue&type=style&index=0&id=46034eef&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports